module.exports = __webpack_public_path__ + "img/example_csv.78a58fbc.png";